$(document).ready(function() {
    // Move recharge app
    if ($(window).width() < 575) {
        $("#shopify-block-AL2E0cFlOYXpZMjVGR__09794b13-c634-4bd5-ad8f-e5ae7a5483db").detach().appendTo(".mobile-third-column");
        setTimeout(function(){
            $("#shopify-block-AL2E0cFlOYXpZMjVGR__09794b13-c634-4bd5-ad8f-e5ae7a5483db").detach().appendTo(".mobile-third-column");
        }, 500);
        
    }
})